import { render, staticRenderFns } from "./manage-left.vue?vue&type=template&id=497eaf42&scoped=true&"
import script from "./manage-left.vue?vue&type=script&lang=ts&"
export * from "./manage-left.vue?vue&type=script&lang=ts&"
import style0 from "./manage-left.vue?vue&type=style&index=0&id=497eaf42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497eaf42",
  null
  
)

export default component.exports